<template>
  <v-icon
    icon="mdi-arrow-up-circle"
    size="60px"
    style="position: fixed; right: 20px; bottom: 20px"
    @click="goTop"
  ></v-icon>
  <NavBar />
  <!-- intro -->
  <div v-if="$route.name == 'home'">
    <Intro />
  </div>
  <!-- read paper -->
  <div v-else-if="$route.name == 'readPaper'">
    <ReadPaper />
  </div>
  <!-- chinese -->
  <div v-else-if="$route.name == 'chinese'">
    <Chinese />
  </div>
</template>

<script>
import NavBar from "@/components/navBar.vue";
import Intro from "@/components/introPage.vue";
import ReadPaper from "@/components/readPaper.vue";
import Chinese from "./components/chinesePage.vue";
export default {
  mounted() {
    this.goTop();
  },
  components: {
    NavBar,
    Intro,
    ReadPaper,
    Chinese,
  },
  methods: {
    goTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style>
#app {
  font-family: "Playfair Display", Georgia, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
